import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { loadFacilitySublimitFilters, loadFacilitySublimitFinancingStructureFilters } from '../../actionCreators';
import { getFacilitySublimit, getFacilitySublimitFilters, getFacilitySublimitFinancingStructureFilters } from '../../selectors';
import SublimitFiltersComponent from './SublimitFiltersComponent';
import WrappedFakeText from 'components/common/WrappedFakeText';

const contentEqual = (prev, next) =>
  prev.loading === next.loading && prev.loaded === next.loaded && prev.content.length === next.content.length;

const SublimitFiltersContainer = ({ sublimitId, siteId, context, onSave, canWrite, isExpanded }) => {
  const dispatch = useDispatch();

  const { loaded: loadedFilters, content: filtersData } = useSelector(state => getFacilitySublimitFilters(sublimitId, state), contentEqual);
  const { loaded: loadedFinancingStructureFilters, content: financingStructureFiltersData } = useSelector(
    state => getFacilitySublimitFinancingStructureFilters(sublimitId, state),
    contentEqual
  );
  const sublimitData = useSelector(state => getFacilitySublimit(sublimitId, state), shallowEqual);

  useEffect(() => {
    if (!sublimitId || !isExpanded) return;
    if (context === 'SUBLIMITFILTERS') dispatch(loadFacilitySublimitFilters(sublimitId, siteId));
    else dispatch(loadFacilitySublimitFinancingStructureFilters(sublimitId, siteId));
  }, [siteId, sublimitId, context, dispatch, isExpanded]);

  const filters = (context === 'SUBLIMITFILTERS' ? filtersData : financingStructureFiltersData) || [];
  const condition = (context === 'SUBLIMITFILTERS' ? sublimitData?.condition : sublimitData?.financingStructureCondition) || null;

  const loaded = context === 'SUBLIMITFILTERS' ? loadedFilters : loadedFinancingStructureFilters;

  return loaded ? (
    <SublimitFiltersComponent
      sublimitId={sublimitId}
      filters={filters}
      condition={condition}
      context={context}
      onSave={onSave}
      canWrite={canWrite}
    />
  ) : (
    <WrappedFakeText p={2} />
  );
};

SublimitFiltersContainer.propTypes = {
  siteId: PropTypes.number,
  sublimitId: PropTypes.number,
  context: PropTypes.string,
  localDispatch: PropTypes.func,
  onSave: PropTypes.func,
  canWrite: PropTypes.bool,
  isExpanded: PropTypes.bool
};

export default SublimitFiltersContainer;
